import { FC } from 'react'
import { Button } from '@mui/material'
import { useIntl } from 'react-intl'
import env from '@consts/consts'

const MicrosoftLoginButton: FC = () => {
  const { formatMessage } = useIntl()

  const handleMicrosoftLogin = () => {
    const state = Math.random().toString(36).substring(7)
    sessionStorage.setItem('oauth_state', state)

    const params = new URLSearchParams({
      client_id: env.MICROSOFT_CLIENT_ID,
      response_type: 'code',
      redirect_uri: env.REDIRECT_URI,
      scope: 'User.Read email openid profile',
      state: state
    })

    const authUrl = `https://login.microsoftonline.com/${env.MICROSOFT_TENANT_ID}/oauth2/v2.0/authorize?${params.toString()}`
    window.location.href = authUrl
  }

  return (
    <Button
      fullWidth
      size='large'
      variant='outlined'
      onClick={handleMicrosoftLogin}
      sx={{
        mb: 2,
        borderColor: '#0078d4',
        color: '#0078d4',
        '&:hover': {
          borderColor: '#106ebe',
          backgroundColor: 'rgba(0, 120, 212, 0.04)'
        }
      }}
    >
      <svg width='20' height='20' viewBox='0 0 21 21' style={{ marginRight: '12px' }}>
        <rect x='1' y='1' width='9' height='9' fill='#f25022' />
        <rect x='1' y='11' width='9' height='9' fill='#00a4ef' />
        <rect x='11' y='1' width='9' height='9' fill='#7fba00' />
        <rect x='11' y='11' width='9' height='9' fill='#ffb900' />
      </svg>
      {formatMessage({
        id: 'login.form.microsoft',
        defaultMessage: 'Zaloguj z Microsoft'
      })}
    </Button>
  )
}

export default MicrosoftLoginButton
